import React, { useContext, useState } from "react";
import { AuthContext } from "../../context/authContext/authContext";
import { Spinner } from "../../components/Spinner";
import { SocketContext } from "../../context/SocketContext";
// import imagenes
import logoTeleapp from "../../assets/img/logos/logotp.png";
import logoTotalProtect from "../../assets/img/logos/Total Protect blanco.png";
import Swal from "sweetalert2";
import { right } from "@popperjs/core";

export const LoginScreen = () => {
  const [loading, setLoading] = useState(false);
  const { login } = useContext(AuthContext);
  const { socket } = useContext(SocketContext);
  const [form, setForm] = useState({
    username: "",
    password: "",
  });
  const handleChange = (event) => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };
  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    let resp = await login(form.username, form.password);
    setLoading(false);
    if (resp.ok) {
      const { user } = resp;
      const { token } = user;
      localStorage.setItem("xt", token);
      if (user.rol === "S.W.A.T") {
        window.location.href = "/tablero";
      } else if (user.rol === "Invitado") {
        window.location.href = "/tablero";
      }  else if (user.rol !== "Administrador de cedis") {
        window.location.href = "/programar-salida";
      } else {
        window.location.href = "/programar-ruta";
      }
      // navigate("/programar-salida");
    } else {
      Swal.fire({ title: "¡Ohhh no!", text: resp.msg, icon: "error" });
    }
  };
  const { username, password } = form;
  return (
    <>
      {loading && <Spinner></Spinner>}
      <div className="login-bg">
        <div style={{ backgroundColor: "rgba(0, 0, 0, 0.5)", height: "100%", position: "absolute", width: "100%"}}>
          <div className="col-12 col-sm-12 col-md-9 col-xl-6 mx-auto">
            <div className="login-card animated">
              <div className="col-12 col-md-10 text-center mx-auto">
                <img src={logoTotalProtect} alt="" className="mt-3 mb-1 img-fluid" />
              </div>
              <form onSubmit={submit} className="col-12 mx-auto mb-2">
                <input
                  className="form-control my-5"
                  type={username.includes("@") ? "email" : "text"}
                  name="username"
                  value={username}
                  onChange={handleChange}
                  placeholder="Correo ó número de empleado"
                  required={true}
                />
                <input
                  type="password"
                  className="form-control my-3"
                  name="password"
                  value={password}
                  onChange={handleChange}
                  placeholder="Contraseña"
                  required={true}
                />
                <input
                  style={{background: "rgb(54 58 63)", color: "white", fontWeight: "bold"}}
                  type="submit"
                  value="Entrar"
                  className="mt-4 btn btn-lg btn-block w-100 mx-0"
                />
              </form>
              <p style={{color: "#fff", fontSize: "12px", float: "right"}}>v5.3</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
